module.exports = __webpack_public_path__ + "static/news-f14fd41e129a6ca260aef3e2707d9278.jpg";